<template>
  <div class="ApprovalModal">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      width="30%"
    >
      <template v-if="form.states === 2">
        <div class="agreeBox">请确认你已经预览整个课程，并通过审核！</div>
      </template>
      <template v-if="form.states === 3">
        <el-form ref="form" :rules="rules" :model="form" size="small">
          <el-form-item label="修改意见:" prop="comment">
            <el-input type="textarea" v-model="form.comment"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <div class="footer">
        <el-button
          style="width: 80px"
          size="small"
          type="primary"
          plain
          @click="handleCancel"
          >取消
        </el-button>
        <el-button
          style="width: 80px"
          size="small"
          type="primary"
          @click="handleConfirm"
          >确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "ApprovalModal",
  props: {
    states: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      title: "",
      form: {
        comment: "",
        lessonId: null,
        version: null,
        states: null,
      },
      rules: {
        comment: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("teachingCenter", ["lessonVerifyResponseList"]),
    visible: {
      get() {
        return this.$store.state.teachingCenter.approvalModalVisible;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "approvalModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapActions("teachingCenter", [
      "verifyLessonVersion",
      "getLessonVerifyResponseList",
    ]),
    handleOpen() {
      this.form.lessonId = Number(
        this.$Base64.decode(this.$route.params.lessonId)
      );
      this.form.version = Number(
        this.$Base64.decode(this.$route.params.version)
      );
      this.form.comment = "";
      this.form.states = this.states;
      if (this.form.states === 2) {
        this.title = "通过";
      }
      if (this.form.states === 3) {
        this.title = "驳回";
      }
    },
    handleCancel() {
      this.setData({ key: "approvalModalVisible", value: false });
    },
    async handleConfirm() {
      // 驳回
      if (this.form.states === 3) {
        await this.$refs.form.validate(async (valid) => {
          if (valid) {
            await this.verifyLessonVersion({
              ...this.form,
            });
            this.$message.success("操作成功");
            this.setData({ key: "approvalModalVisible", value: false });
            await this.getLessonVerifyResponseList({
              page: this.lessonVerifyResponseList.page,
              size: this.lessonVerifyResponseList.size,
            });
            await this.$router.go(-1);
          }
        });
      }
      //   通过
      if (this.form.states === 2) {
        await this.verifyLessonVersion({
          ...this.form,
        });
        this.$message.success("操作成功");
        this.setData({ key: "approvalModalVisible", value: false });
        await this.getLessonVerifyResponseList({
          page: this.lessonVerifyResponseList.page,
          size: this.lessonVerifyResponseList.size,
        });
        await this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ApprovalModal {
  ::v-deep .el-dialog {
    margin-top: 30vh !important;
    width: 450px;
  }

  ::v-deep .el-textarea__inner {
    min-height: 150px !important;
  }

  .agreeBox {
    text-align: center;
    padding: 30px 0;
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 30px;
  }
}
</style>
